package nl.staartvin.solarpower.data.net

import io.ktor.client.HttpClient
import io.ktor.client.HttpClientConfig
import io.ktor.client.plugins.HttpTimeout
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.serialization.kotlinx.json.json

/**
 * Platform-specific HTTP client. Each platform (Android/iOS) installs its own
 * Ktor engine — OkHttp on JVM/Android, Darwin on iOS — and these engines live
 * in different artifacts. So we ask each platform to supply its own client
 * with a shared `block` of plugins applied on top.
 *
 * This is the classic KMP `expect` declaration: signature lives here, the
 * compiler requires every target source set to provide a matching `actual`.
 */
expect fun httpClient(block: HttpClientConfig<*>.() -> Unit = {}): HttpClient

/** App-wide configured client: shared JSON + bounded timeouts. */
fun appHttpClient(): HttpClient = httpClient {
    install(ContentNegotiation) { json(AppJson) }
    // Without HttpTimeout, a stalled request can hang forever — leaving the
    // UI on its Loading spinner with no recovery path. Bound it tightly enough
    // that a user on a flaky connection sees an error instead of perpetual loading.
    install(HttpTimeout) {
        connectTimeoutMillis = 10_000   // 10s to establish TCP/TLS
        requestTimeoutMillis = 30_000   // 30s for the whole request
        socketTimeoutMillis = 30_000    // 30s of inactivity on an open socket
    }
}
